// Match Availability (138) -- "who's in for Saturday?"
//
// A coach requests availability for a fixture; the request seeds a no_reply row
// per roster player. Parents (ParentPlayer) or the player themselves (119) reply
// available / out / maybe. The coach sees a live tally and nudges no-replies.

export const AVAILABILITY_STATUSES = ["available", "out", "maybe", "no_reply"] as const;
export type MatchAvailabilityStatus = (typeof AVAILABILITY_STATUSES)[number];

/** A status a parent/player may actively choose (excludes the seeded no_reply). */
export const AVAILABILITY_REPLY_STATUSES = ["available", "out", "maybe"] as const;
export type MatchAvailabilityReply = (typeof AVAILABILITY_REPLY_STATUSES)[number];

/** Per-fixture counts across the targeted roster. total == sum of the rest. */
export interface MatchAvailabilityTally {
  available: number;
  out: number;
  maybe: number;
  no_reply: number;
  total: number;
}

/** One roster player's current availability for a fixture. */
export interface MatchAvailabilityPlayer {
  player_id: string;
  player_name: string;
  status: MatchAvailabilityStatus;
  note: string | null;
  responded_at: string | null; // ISO; null while no_reply
}

/** GET /matches/:matchId/teams/:teamId/availability -- coach/admin view. */
export interface MatchAvailabilityResponse {
  match_id: string;
  team_id: string;
  team_name: string;
  requested: boolean; // any row exists for (match, team)
  tally: MatchAvailabilityTally;
  players: MatchAvailabilityPlayer[];
  _actions: Array<"request" | "view" | "nudge">;
}

/** One pending request surfaced to a parent/player (GET /me/availability-requests). */
export interface PendingAvailabilityRequest {
  match_id: string;
  team_id: string;
  player_id: string;
  player_name: string;
  match_name: string;
  event_id: string;
  event_name: string;
  starts_at: string; // ISO -- fixture kickoff
  venue: string | null;
  team_name: string;
  opponents: string[];
  current_status: MatchAvailabilityStatus; // no_reply for genuinely pending; included for re-open
  note: string | null;
}

export interface PendingAvailabilityResponse {
  requests: PendingAvailabilityRequest[];
}
